import type React from 'react'
import { Horizontal, Texto, addCommasToNumber } from '@gravitate-js/excalibrr'

interface ProductOptionProps {
  product: string
  grossVol: number
  netVol: number
}

export const ProductOption: React.FC<ProductOptionProps> = ({ product, grossVol, netVol }) => (
  <Horizontal gap={16} justifyContent='space-between' verticalCenter>
    <Texto>{product}</Texto>
    <Horizontal gap={8} verticalCenter>
      <Texto category='label' appearance='hint'>
        Gross: {addCommasToNumber(grossVol, 0)}
      </Texto>
      <Texto category='label' appearance='hint'>
        Net: {addCommasToNumber(netVol, 0)}
      </Texto>
    </Horizontal>
  </Horizontal>
)
